import { computed } from 'mobx';
import { IsDefined, IsNotEmpty } from 'class-validator';
import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model, BookemZulu } from 'src/core/services/data/JayDataContext';

export class AllotmentDataService extends DataService<typeof Model.Products.Logic.ViewModels.AllotmentItem, Model.Products.Logic.ViewModels.AllotmentItem, AllotmentItem> {
	private id = -1;

	protected map(entity: Model.Products.Logic.ViewModels.AllotmentItem): AllotmentItem {
		return new AllotmentItemModel(entity);
	}

	static make(context?: any): AllotmentDataService {
		return new AllotmentDataService(context, ctx => ctx.Allotments);
	}
	add(product?: ProductItem | TourItineraryItem, supplierId?: number, defaultLanguaje?: string) {
		const entity = new Model.Products.Logic.ViewModels.AllotmentItem();
		entity.id = this.id--;
		entity.name = '';
		entity.byDefault = true;
		if (product) {
			entity.name = product.dynamicProperties["displayName"][defaultLanguaje];
			if (product.id != null)
				entity.productId = product.id;
			if (product.entity.getType() == Model.Products.Logic.ViewModels.ProductItem) {
				let prod = product as ProductItem
				if (prod.productType != null)
					entity.productType = prod.productType;
				if (prod.categoryId != null)
					entity.categoryId = prod.categoryId;
			}
			else {
				// TODO los itinerarios tiene allotment
			}
		}

		if (supplierId != null)
			entity.supplierId = supplierId;

		return this.create(() => entity);
	}
}

export class AllotmentItemModel extends EntityModel<Model.Products.Logic.ViewModels.AllotmentItem, AllotmentItem> implements AllotmentItem {
	@property<AllotmentItemModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@IsDefined({ message: 'Name is required' })
	@IsNotEmpty({ message: 'Name is required' })
	@property<AllotmentItemModel>(o => o.entity.name, (o, value) => o.entity.name = value)
	public name: string;

	@property<AllotmentItemModel>(o => o.entity.parentAllotmentId, (o, value) => o.entity.parentAllotmentId = value)
	public parentAllotmentId: number;

	@property<AllotmentItemModel>(o => o.entity.allotmentRanges, (o, value) => o.entity.allotmentRanges = value)
	public allotmentRanges: any[];

	@property<AllotmentItemModel>(o => o.entity.contracts, (o, value) => o.entity.contracts = value)
	public contracts: ContractItem[];
	@IsDefined({ message: 'Product is required' })
	@IsNotEmpty({ message: 'Product is required' })
	@property<AllotmentItemModel>(o => o.entity.productId, (o, value) => o.entity.productId = value)
	public productId: number;

	@property<AllotmentItemModel>(o => o.entity.product, (o, value) => o.entity.product = value)
	public product: any;

	@IsDefined({ message: 'Supplier is required' })
	@IsNotEmpty({ message: 'Supplier is required' })
	@property<AllotmentItemModel>(o => o.entity.supplierId, (o, value) => o.entity.supplierId = value)
	public supplierId: number;

	@property<AllotmentItemModel>(o => o.entity.productType, (o, value) => o.entity.productType = value)
	public productType: BookemZulu.Core.Models.ProductType;

	@property<AllotmentItemModel>(o => o.entity.categoryId, (o, value) => o.entity.categoryId = value)
	public categoryId?: number;

	@property<AllotmentItemModel>(o => o.entity.byDefault, (o, value) => o.entity.byDefault = value)
	public byDefault: boolean;

	public async validate(validateChildren: boolean, property?: string): Promise<ValidationError[]> {
		let result = await super.validate(validateChildren, property);
		if (validateChildren && this.allotmentRanges)
			for (let range of this.allotmentRanges) {
				let rangeError = await range.validate(false);
				result = result.concat(rangeError);

			}
		return result;
	}
}



// WEBPACK FOOTER //
// ./src/app/products/allotment/form/allotment-form.data.ts